import { IonImg } from '@ionic/react';

import AppStoreBadge from '@/assets/imgs/app-store-badge.svg';
import GooglePlayBadge from '@/assets/imgs/google-play-badge.svg';

import styles from './LoginAd.module.scss';

export default function LoginAd() {
  return (
    <div className={styles.badgesWrapper}>
      <a
        className={styles.appBadge}
        href="https://play.google.com/store/apps/details?id=com.pepperfinance.merchants"
        target="_blank"
        rel="noopener noreferrer"
      >
        <IonImg src={GooglePlayBadge} />
      </a>
      <a
        className={styles.appBadge}
        href="https://apps.apple.com/es/app/pepper-comercios/id6443717699"
        target="_blank"
        rel="noopener noreferrer"
      >
        <IonImg src={AppStoreBadge} />
      </a>
    </div>
  );
}
